import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Estoque } from '../models/estoque';
import { EstoqueRequest } from '../models/estoque-request';


@Injectable({
  providedIn: 'root'
})
export class EstoqueService {

  private url = `${environment.apiUrl}/estoque`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<Estoque[]> {
    return this.http.get<Estoque[]>(this.url);
  }

  adicionar(estoqueRequest: EstoqueRequest): Observable<string> {
    return this.http.post<string>(`${this.url}/adicionar`, estoqueRequest);
  }

  remover(estoqueRequest: EstoqueRequest): Observable<string> {
    return this.http.post<string>(`${this.url}/remover`, estoqueRequest);
  }
}